/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect } from 'react';
import {
  Text,
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
  Pressable,
} from 'react-native';
import Image from '@web/components/common/Image';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { searchProductRequest } from '~store/create-review/thunks';
import { getRecentlyBought } from '~store/my-reviews/thunks';
import CardInlineReview from '@web-components/common/CardInlineReview';
import * as search from '~store/search/thunks';
import { isNative, isWeb } from '~global/screens';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import Colors from '~global/Colors';
import { getProduct } from '~store/product-detail/thunks';
import NoReviews from '@web-components/common/NoReviews';
import InputSearchBar from '@web-components/create-review/InputSearchBar';
import SearchProductPlaceHolder from '@web-components/create-review/SearchProductPlaceHolder';
const iconSparklesSource = require('~assets/img/common/icon-sparkles.png');
import { IcoProfile } from '@web/components/profile/snippets/commons';
let CancelToken;
let source;
const SelectProduct = (props) => {
  const dispatch = useDispatch();
  const { navigation } = props;
  const { axios } = global;
  const recentlyBought = useSelector((state) => state.myReviews.recentlyBought);
  const searchProductResult = useSelector(
    (state) => state.createReview.searchProductResult,
  );
  const statusApi = useSelector((state) => state.createReview.status);
  const statusApiRecentlyBought = useSelector(
    (state) => state.myReviews.status.recentlyBought,
  );
  const popularProductsStatus = useSelector(
    (state) => state.search.status.popularProducts,
  );
  const productCombinationById = useSelector(
    (state) => state.productDetail.product,
  );

  const getRecentlyBoughtRequest = async () => {
    try {
      const resultAction = await dispatch(getRecentlyBought());
      // eslint-disable-next-line no-unused-vars
      const responseApi = unwrapResult(resultAction);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getRecentlyBoughtRequest();
  }, []);

  useEffect(() => {
    if (productCombinationById) {
      dispatch({
        type: 'createReview/setSelectedProduct',
        data: productCombinationById,
      });
    }
  }, [productCombinationById]);

  useEffect(() => {
    if (recentlyBought.length < 1) {
      dispatch(search.getPopularProducts());
    }
  }, [recentlyBought]);

  const searchHandler = async (value) => {
    dispatch({ type: 'createReview/setInputSearchText', value });

    if (!value || value.length < 2) {
      if (typeof source !== 'undefined') {
        dispatch({
          type: 'createReview/setStatusApi',
          name: 'searchProductResult',
          value: 'idle',
        });
        source.cancel();
      }
      return;
    } else {
      dispatch({
        type: 'createReview/setStatusApi',
        name: 'searchProductResult',
        value: 'idle',
      });
      dispatch({
        type: 'createReview/setState',
        name: 'searchProductResult',
        value: [],
      });
    }

    if (typeof source !== 'undefined') {
      source.cancel(false);
    }
    CancelToken = axios.CancelToken;
    source = CancelToken.source();

    const params = {
      params: {
        filter: {
          keyword: value,
          is_reviewed: true,
          is_purchased_product: true,
        },
        limit: 10,
        skip: 0,
      },
      cancelToken: source.token,
    };

    await dispatch(searchProductRequest(params));
  };
  const selectProductHandler = async (product, type) => {
    const dataProduct = JSON.parse(JSON.stringify(product));

    dispatch({
      type: 'createReview/setState',
      name: 'productReviewType',
      value: type,
    });
    if (
      Array.isArray(product.combinations) &&
      product.combinations.length > 1
    ) {
      await dispatch(getProduct(product?.id));
      dispatch({
        type: 'createReview/setState',
        name: 'section',
        value: 'choose_combination',
      });
    } else {
      dispatch({
        type: 'createReview/setSelectedProduct',
        data: dataProduct,
      });
      if (isWeb) {
        dispatch({ type: 'MODAL/HIDE', modalName: 'addReviewRecentlyBought' });
        return navigation.navigate('CreateReviewScreenDesktop', {
          id: dataProduct?.id,
        });
      }
      dispatch({
        type: 'createReview/setState',
        name: 'selectedIndexCombination',
        value: 0,
      });
      dispatch({
        type: 'createReview/setState',
        name: 'section',
        value: 'give_rating',
      });
    }
  };

  const closeModal = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'addReviewRecentlyBought' });
  };

  const continueShopping = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'addReviewRecentlyBought' });
    navigation.navigate('HomeScreen');
  };

  return (
    <SafeAreaView style={styles.wrapper} showsVerticalScrollIndicator={false}>
      <View style={styles.selectProductContainer}>
        <View style={styles.head}>
          <View style={styles.selectProductInfoContainer}>
            <View style={styles.headerTitleWrapper}>
              <Text style={styles.selectProductHeading}>
                Yuk, Tulis Review!
              </Text>
              {isWeb && (
                <Pressable
                  style={styles.modalProductClose}
                  onPress={closeModal}>
                  <WithLocalSvg
                    width={14}
                    height={14}
                    asset={require('~assets/img/product/icon-close.svg')}
                  />
                </Pressable>
              )}
            </View>

            <Text style={styles.selectProductText}>
              Bagikan pengalamanmu dan dapatkan{' '}
              <Text style={styles.selectProductTextBolder}>
                +20 SP
                <Image
                  source={IcoProfile.socoPoints}
                  style={styles.iconSocoIcon}
                  resizeMode="cover"
                />
              </Text>
              untuk setiap Trusted Review yang kamu bagikan!
            </Text>
          </View>

          <View style={styles.selectProductInfoIconContainer}>
            <Image
              source={iconSparklesSource}
              style={styles.iconSparkles}
              resizeMode="cover"
            />
          </View>

          <View style={styles.inputSearchContainer}>
            <InputSearchBar searchHandler={searchHandler} />
          </View>
        </View>

        <ScrollView>
          <View style={styles.body}>
            {statusApi.searchProductResult === 'loading' ||
            statusApiRecentlyBought === 'loading' ||
            popularProductsStatus === 'pending' ? (
              <SearchProductPlaceHolder />
            ) : (
              <>
                {statusApi.searchProductResult === 'idle' ? (
                  <View>
                    <Text style={styles.bodyHeading}>
                      Share Your Experience
                    </Text>
                    {recentlyBought?.length ? (
                      <View style={styles.listProductWrapper}>
                        {(recentlyBought || []).map((product, index) => (
                          <TouchableOpacity
                            key={`CardInlineReview${index}`}
                            style={styles.productGrid}
                            onPress={() => {
                              selectProductHandler(product, 'recentlyBought');
                            }}>
                            <CardInlineReview
                              review={product}
                              containerStyle={styles.cardInlineReview}
                              type="select_product"
                              productType="recently_bought"
                              showCount={true}
                              navigation={navigation}
                            />
                          </TouchableOpacity>
                        ))}
                      </View>
                    ) : (
                      <View style={styles.noReviewWrapper}>
                        <NoReviews onPress={continueShopping} />
                      </View>
                    )}
                  </View>
                ) : (
                  <>
                    {searchProductResult.length ? (
                      <>
                        {searchProductResult.map((review, index) => (
                          <TouchableOpacity
                            key={`CardInlineReview${index}`}
                            onPress={() => {
                              selectProductHandler(review);
                            }}>
                            <CardInlineReview
                              review={review}
                              containerStyle={styles.cardInlineReview}
                              type="select_product"
                              showCount={true}
                              navigation={navigation}
                            />
                          </TouchableOpacity>
                        ))}
                      </>
                    ) : (
                      <View style={styles.noResultContainer}>
                        <View style={styles.noResult}>
                          <Image
                            source={require('~assets/img/my-reviews/default-no-result.png')}
                            style={styles.iconDefaultNoResult}
                          />
                          <Text style={styles.noResultText}>
                            Maaf, tidak ada produk yang ditemukan
                          </Text>
                        </View>
                      </View>
                    )}
                  </>
                )}
              </>
            )}
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  body: {
    paddingTop: isWeb ? 0 : 40,
    flexGrow: 1,
    maxHeight: 320,
  },
  bodyHeading: {
    fontFamily: 'satoshi-black',
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0,
    color: Colors.purple7,
    paddingHorizontal: 16,
    marginTop: 15,
  },
  cardInlineReview: {
    width: '100%',
    borderWidth: 0,
    borderBottomWidth: 1,
    borderBottomColor: '#F1F1F1',
  },
  head: {
    backgroundColor: Colors.purple18,
    height: 168,
    padding: 20,
    position: 'relative',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    marginBottom: 20,
  },
  iconDefaultNoResult: {
    height: 62,
    width: 76,
    marginBottom: 13,
  },
  iconSparkles: {
    height: isWeb ? 76 : 93,
    width: isWeb ? 86 : 83,
  },
  iconSocoIcon: {
    width: 16,
    height: 17,
    marginLeft: 3,
    marginRight: 3,
  },
  inputSearchContainer: {
    position: 'absolute',
    left: 16,
    right: 16,
    bottom: -22,
    zIndex: 19,
  },
  noResult: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  noResultContainer: {
    marginTop: 45,
  },
  noResultText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'satoshi-medium',
    color: Colors.grey2,
  },
  noReviewWrapper: { marginBottom: 70 },
  selectProductContainer: {
    flexGrow: 1,
  },
  selectProductInfoIconContainer: {
    position: 'absolute',
    right: isWeb ? 92 : 16,
    top: 29,
  },
  selectProductHeading: {
    fontFamily: 'satoshi-black',
    fontSize: isWeb ? 20 : 17,
    lineHeight: 22,
    color: Colors.purple7,
    marginBottom: 8,

    ...(isWeb && {
      marginBottom: 6,
      marginTop: 18,
      marginLeft: 16,
    }),
  },
  selectProductText: {
    fontFamily: isWeb ? 'satoshi-bold' : 'satoshi-medium',
    fontSize: 13,
    lineHeight: 18,
    color: Colors.white,
    ...(isWeb ? { width: 320, marginLeft: 17 } : { width: 220 }),
  },
  selectProductTextBolder: {
    fontFamily: 'satoshi-black',
    color: Colors.purple7,
    display: 'inline-flex',
  },
  selectProductInfoContainer: {
    ...(isNative && { width: 216 }),
  },
  wrapper: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  listProductWrapper: {
    ...(isWeb && { flexDirection: 'row', flexWrap: 'wrap', marginBottom: 15 }),
  },
  productGrid: {
    ...(isWeb && { width: '50%', padding: 8 }),
  },
  modalProductClose: {
    position: 'absolute',
    right: 7,
    width: 22,
    height: 22,
    alignItems: 'center',
    justifyContent: 'center',
    ...(isWeb && { cursor: 'pointer' }),
  },
  headerTitleWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default SelectProduct;
